import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import FactSource from './common/FactSource';
import TotalProductCount from './common/TotalProductCount';

class Category extends Component {
	render() {
		const pageTitle = 'Water and Fireproof Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<TopProducts
					title={ `Best Selling ${pageTitle}` }
					subTitle="When the unimaginable happens, know your valuables are protected."
					path="fire-waterproof-safes"
					buttonCTA={ `View all ${pageTitle}` }
					topProduct={ this.props.featuredProduct }
				/>
			);
		}

		return (
			<div className="category category-water-and-fireproof">
				<Helmet>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="SentrySafe offers various levels of technology to protect your valuables from the unexpected. View water and fireproof safes." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/water-and-fireproof-safes.jpg') }
					imageAlt="Couple moving into new home"
					title={ pageTitle }
					description="Safeguard your belongings from the most unexpected perils."
				/>

				<TrustedSection
					content="It&rsquo;s not just fire that can threaten to damage your home. Whether you live in a flood plain, a hurricane rages through your town, or pipe bursts in your basement, a flood can happen to anyone. And protecting treasured valuables, cherished memories, and important business assets from the devastating effects of both water and fire damage is a top priority for many families. SentrySafe is proud to offer fire safes with various levels of waterproof and water&#45;resistant technology to ensure you have what you need if disaster strikes."
				/>

				{ topProducts }

				<section className="row hour-test">
					<div className="col sm-12">
						<h3 className="title">The Most Reliable Water Protection</h3>
						<p className="descr">In addition to providing superior fire protection you can trust, our water and fireproof safes also safeguard against water damage.</p>
					</div>
					<div className="callouts">
						<div className="col sm-3">
							<h3 className="sub-title">Water Submersion Testing</h3>
							<p>Waterproof chests and files consistently deliver up to 72 hours of powerful protection from water intrusion. So even if you&rsquo;re stuck away from your home after a flood or hurricane, you&rsquo;ll know the things you value are safe.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">How Waterproofing Works</h3>
							<p>All SentrySafe waterproof products include a closed&#45;cell foam gasket. That means when the lid is closed, pressure forms a durable barrier between the water outside your safe and your valuables inside.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">ETL Verified Protection</h3>
							<p>In addition to our own testing, the independent testing firm ETL thoroughly tests and verifies our water submersion and resistance ratings to ensure our safes protect against flooding and other water damage. SentrySafe products lead the industry in water protection, so you can rest assured your important documents, digital media, photos and keepsakes will survive catastrophe.</p>
						</div>
					</div>
				</section>

				<section className="row certification">
					<div className="col">
						<h2>Water Resistant Fire Safes</h2>
					</div>
					<div className="col descr">
						<p>Our line of <Link to="/fire-safes">Fire Safes</Link> also deliver up to 72 hours of powerful protection from water intrusion.</p>
					</div>
				</section>

				<FactSource
					title="Did you know&#63;"
					fact="Floods are the &#35;1 natural disaster in the United States. And water damage is one of the most common claims on home insurance and it is estimated that your home has a 26&#37; chance of being damaged by a flood during the course of a 30&#45;year period. In fact, people outside of mapped high&#45;risk flood areas file over 20&#37; of all National Flood Insurance Program flood insurance claims."
					imgeSrc={ require('../../resources/img/callouts/did-you-know-house-fire.png') }
					alt="Burning House"
				/>

				<TotalProductCount
					link="fire-waterproof-safes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/FireWaterproofCategory.js